import { Component, OnInit, inject } from '@angular/core';
import { TransitionService } from '@app/core/services';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'jeopardy-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    imports: [AsyncPipe]
})
export class LoaderComponent implements OnInit {

  public transitionService = inject(TransitionService);

  ngOnInit(): void {}

}
